// @ts-ignore
const isArray = function (a) {
  return Array.isArray(a);
};

// @ts-ignore
const isObject = function (o) {
  return o === Object(o) && !isArray(o) && typeof o !== "function";
};

// @ts-ignore
export const keysToCamelCase = function (o) {
  if (isObject(o)) {
    const n = {};

    Object.keys(o).forEach((k) => {
      // @ts-ignore
      n[toCamelCase(k)] = keysToCamelCase(o[k]);
    });

    return n;
  } else if (isArray(o)) {
    // @ts-ignore
    return o.map((i) => {
      return keysToCamelCase(i);
    });
  }
  return o;
};
